export interface AllLiveGameData {
  activePlayer: ActivePlayer
  allPlayers: AllPlayer[]
  events: Events
  gameData: GameData
}

export interface ActivePlayer {
  abilities: Abilities
  championStats: ChampionStats
  currentGold: number
  fullRunes: FullRunes
  level: number
  summonerName: string
}

export interface Abilities {
  E: AbilityInfo
  Q: AbilityInfo
  R: AbilityInfo
  W: AbilityInfo
  Passive: AbilityInfo
}

export interface AbilityInfo {
  abilityLevel?: number
  displayName: string
  id?: string
  rawDescription: string
  rawDisplayName: string
}

export interface ChampionStats {
  abilityPower: number
  armor: number
  armorPenetrationFlat: number
  armorPenetrationPercent: number
  attackDamage: number
  attackRange: number
  attackSpeed: number
  bonusArmorPenetrationPercent: number
  bonusMagicPenetrationPercent: number
  cooldownReduction: number
  critChance: number
  critDamage: number
  currentHealth: number
  healthRegenRate: number
  lifeSteal: number
  magicLethality: number
  magicPenetrationFlat: number
  magicPenetrationPercent: number
  magicResist: number
  maxHealth: number
  moveSpeed: number
  physicalLethality: number
  resourceMax: number
  resourceRegenRate: number
  resourceType: string
  resourceValue: number
  spellVamp: number
  tenacity: number
}

export interface FullRunes {
  generalRunes: Keystone[]
  keystone: Keystone
  primaryRuneTree: Keystone
  secondaryRuneTree: Keystone
  statRunes: StatRune[]
}

export interface Keystone {
  displayName: string
  id: number
  rawDescription: string
  rawDisplayName: string
}

export interface StatRune {
  id: number
  rawDescription: string
}

export interface AllPlayer {
  championName: string
  isBot: boolean
  isDead: boolean
  items: Item[]
  level: number
  position: string
  rawChampionName: string
  respawnTimer: number
  runes: Runes
  scores: Scores
  skinID: number
  summonerName: string
  summonerSpells: SummonerSpells
  team: string
}

export interface Item {
  canUse: boolean
  consumable: boolean
  count: number
  displayName: string
  itemID: number
  price: number
  rawDescription: string
  rawDisplayName: string
  slot: number
}

export interface Runes {
  keystone: Keystone
  primaryRuneTree: Keystone
  secondaryRuneTree: Keystone
}

export interface Scores {
  assists: number
  creepScore: number
  deaths: number
  kills: number
  wardScore: number
}

export interface SummonerSpells {
  summonerSpellOne: AbilityInfo
  summonerSpellTwo: AbilityInfo
}

export interface Events {
  Events: Event[]
}

export interface Event {
  EventID: number
  EventName: GameEventType
  EventTime: number
  Assisters?: string[]
  KillerName?: string
  TurretKilled?: string
}

export enum GameEventType {
  EVENT_GAMESTART = 'GameStart',
  EVENT_MINIONSSPAWNING = 'MinionsSpawning',
  EVENT_FIRSTBRICK = 'FirstBrick',
  EVENT_TURRETKILLED = 'TurretKilled',
  EVENT_INHIBKILLED = 'InhibKilled',
  EVENT_DRAGONKILL = 'DragonKill',
  EVENT_HERALDKILL = 'HeraldKill',
  EVENT_BARONKILL = 'BaronKill',
  EVENT_CHAMPIONKILL = 'ChampionKill',
  EVENT_MULTIKILL = 'Multikill',
  EVENT_ACE = 'Ace'
}

export interface GameData {
  gameMode: GameMode
  gameTime: number
  mapName: string
  mapNumber: number
  mapTerrain: string
}

export enum GameMode {
  CLASSIC = 'CLASSIC',
  ODIN = 'ODIN',
  ARAM = 'ARAM',
  TUTORIAL = 'TUTORIAL',
  URF = 'URF',
  DOOMBOTSTEEMO = 'DOOMBOTSTEEMO',
  ONEFORALL = 'ONEFORALL',
  ASCENSION = 'ASCENSION',
  FIRSTBLOOD = 'FIRSTBLOOD',
  KINGPORO = 'KINGPORO',
  SIEGE = 'SIEGE',
  ASSASSINATE = 'ASSASSINATE',
  ARSR = 'ARSR',
  DARKSTAR = 'DARKSTAR',
  STARGUARDIAN = 'STARGUARDIAN',
  PROJECT = 'PROJECT',
  GAMEMODEX = 'GAMEMODEX',
  ODYSSEY = 'ODYSSEY',
  NEXUSBLITZ = 'NEXUSBLITZ'
}

export enum GameMap {
  SUMMONER_RIFT_SUMMER = 1,
  SUMMONER_RIFT_AUTUMN = 2,
  THE_PROVING_GROUND_TUTORIAL = 3,
  TWISTED_TREELINE_ORIGINAL = 4,
  THE_CRYSTAL_SCAR_DOMINION = 8,
  TWISTED_TREELINE_LAST_TT = 10,
  SUMMONER_RIFT = 11,
  HOWLING_ABYSS = 12,
  BUTCHERS_BRIDGE = 14,
  COSMIC_RUINS = 16,
  VALORAN_CITY_PARK = 18,
  SUBSTRUCTURE_43 = 19,
  CONVERGENCE = 20,
  NEXUS_BLITZ = 21
}

export enum GameType {
  CUSTOM_GAME = 'CUSTOM_GAME',
  TUTORIAL_GAME = 'TUTORIAL_GAME',
  MATCHED_GAME = 'MATCHED_GAME'
}
